<!-- <div class="d-flex flex-row justify-content-center">
	<div *ngFor="let option of options" (click)="onSelect(option.id)" 
		class="m-box m-2 p-4 text-center" [ngClass]="{'selected':option.id===selectedOption}">
		<i class="p-2 fa fa-{{option.class}}"></i>
		<br/>
		<div class="">{{option.label | translate}}</div>
	</div>
</div> -->

<!-- <div class="d-flex flex-row justify-content-center">
	<div *ngFor="let option of options" (click)="onSelect(option.id)" 
		class="m-box m-2 p-4 text-center btn-group-toggle" [ngClass]="{'selected':option.id===selectedOption}" data-toggle="buttons">
		<label>
			<input type="radio" value="YES" (change)="onSubmit(userDetails)" style="position: absolute;opacity: 0;" name="radioInput">
			<i class="p-2 fa fa-{{option.class}}"></i>
			<span style="display:block;">{{option.label|translate}}</span>
		</label>
		<br/>
	</div>
</div> -->

<div class="d-flex flex-column justify-content-center flex-sm-wrap flex-sm-row">
	<div *ngFor="let option of options" data-toggle="buttons">
		<label>
			<input (keyup.enter)="onSelect(option.id)" type="radio" value="YES" style="position: absolute; opacity: 0;" name="radioInput" (change)="onSelect(option.id)">
			<div tabindex="0" class="m-box btn-group-toggle square" [ngClass]="{'selected':option.id===selectedOption}">
				<div class="m-box-image {{option.class}}"></div>
				<div class="m-box-title mx-auto pt-3">{{option.label|translate}}  </div>
			</div>
		</label>
		<br/>
	</div>
</div>



// WEBPACK FOOTER //
// ./src/app/box-selector/box-selector.component.html